import { render, staticRenderFns } from "./QuotationDetail.vue?vue&type=template&id=3b134262&"
import script from "./QuotationDetail.vue?vue&type=script&lang=js&"
export * from "./QuotationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b134262')) {
      api.createRecord('3b134262', component.options)
    } else {
      api.reload('3b134262', component.options)
    }
    module.hot.accept("./QuotationDetail.vue?vue&type=template&id=3b134262&", function () {
      api.rerender('3b134262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/QuotationDetail.vue"
export default component.exports